/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ooL7EhXDmFQWnW9sxtchhE
// Component: VfLXr8Uqdd

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  StrictProps,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import DefaultLayout from "../../components/dashboard/DefaultLayout"; // plasmic-import: nSkQWLjK-B/component
import NavTeamSection from "../../components/dashboard/NavTeamSection"; // plasmic-import: VqaN_WL-stA/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "../PP__plasmickit_dashboard.css"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/projectcss
import sty from "./PlasmicSettingsPage.module.css"; // plasmic-import: VfLXr8Uqdd/css

const emptyProxy: any = new Proxy(() => "", {
  get(_, prop) {
    return prop === Symbol.toPrimitive ? () => "" : emptyProxy;
  },
});

function wrapQueriesWithLoadingProxy($q: any): any {
  return new Proxy($q, {
    get(target, queryName) {
      const query = target[queryName];
      return !query || query.isLoading || !query.data ? emptyProxy : query;
    },
  });
}

export type PageCtx = {
  pageRoute: string;
  pagePath: string;
  params: Record<string, string | string[] | undefined>;
  query: Record<string, string | string[] | undefined>;
};

export function generateDynamicMetadata($q: any, $ctx: PageCtx) {
  return {
    openGraph: {},
    twitter: {
      card: "summary" as const,
    },
  };
}

createPlasmicElementProxy;

export type PlasmicSettingsPage__VariantMembers = {};
export type PlasmicSettingsPage__VariantsArgs = {};
type VariantPropType = keyof PlasmicSettingsPage__VariantsArgs;
export const PlasmicSettingsPage__VariantProps = new Array<VariantPropType>();

export type PlasmicSettingsPage__ArgsType = {};
type ArgPropType = keyof PlasmicSettingsPage__ArgsType;
export const PlasmicSettingsPage__ArgProps = new Array<ArgPropType>();

export type PlasmicSettingsPage__OverridesType = {
  root?: Flex__<"div">;
  defaultLayout?: Flex__<typeof DefaultLayout>;
  navTeamSection?: Flex__<typeof NavTeamSection>;
};

export interface DefaultSettingsPageProps {
  className?: string;
}

const $$ = {};

function PlasmicSettingsPage__RenderFunc(props: {
  variants: PlasmicSettingsPage__VariantsArgs;
  args: PlasmicSettingsPage__ArgsType;
  overrides: PlasmicSettingsPage__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const styleTokensClassNames = _useStyleTokens();

  return (
    <React.Fragment>
      <div className={"plasmic_page_wrapper"}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            "all",
            "root_reset_ooL7EhXDmFQWnW9sxtchhE",
            "plasmic_default_styles",
            "plasmic_mixins",
            styleTokensClassNames,
            sty.root
          )}
        >
          <DefaultLayout
            data-plasmic-name={"defaultLayout"}
            data-plasmic-override={overrides.defaultLayout}
            children={null}
            className={classNames("__wab_instance", sty.defaultLayout)}
            navigation={"starters"}
            teams={
              <NavTeamSection
                data-plasmic-name={"navTeamSection"}
                data-plasmic-override={overrides.navTeamSection}
                className={classNames("__wab_instance", sty.navTeamSection)}
              />
            }
          />
        </div>
      </div>
    </React.Fragment>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "defaultLayout", "navTeamSection"],
  defaultLayout: ["defaultLayout", "navTeamSection"],
  navTeamSection: ["navTeamSection"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  defaultLayout: typeof DefaultLayout;
  navTeamSection: typeof NavTeamSection;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicSettingsPage__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicSettingsPage__VariantsArgs;
    args?: PlasmicSettingsPage__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicSettingsPage__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicSettingsPage__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSettingsPage__ArgProps,
          internalVariantPropNames: PlasmicSettingsPage__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicSettingsPage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicSettingsPage";
  } else {
    func.displayName = `PlasmicSettingsPage.${nodeName}`;
  }
  return func;
}

export const PlasmicSettingsPage = Object.assign(
  // Top-level PlasmicSettingsPage renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    defaultLayout: makeNodeComponent("defaultLayout"),
    navTeamSection: makeNodeComponent("navTeamSection"),

    // Metadata about props expected for PlasmicSettingsPage
    internalVariantProps: PlasmicSettingsPage__VariantProps,
    internalArgProps: PlasmicSettingsPage__ArgProps,

    pageMetadata: generateDynamicMetadata(wrapQueriesWithLoadingProxy({}), {
      pageRoute: "/settings",
      pagePath: "/settings",
      params: {},
      query: {},
    }),
  }
);

export default PlasmicSettingsPage;
/* prettier-ignore-end */
